'use strict';

/**
 * @author Maxim Seredkin
 */

export default ['$scope', '$routeParams', '$window', ' HazardClassesService',
                function($scope, $routeParams, $window,  HazardClassesService) {
                    $scope.taxes = [];
                    HazardClassesService.api.get({
                                           filters: [`'status' EQ 'ENABLED'`],
                                           sorts: ['name:ASC'],
                                       }, (data) => $scope.taxes = data._embedded);
                }];
